import React from 'react';

import InlineCode from '~/components/InlineCode.react';
import SectionCode from '~/components/SectionCode.react';
import SectionDescription from '~/components/SectionDescription.react';
import SectionExample from '~/components/SectionExample.react';
import SectionTitle from '~/components/SectionTitle.react';

import { rangeCode } from '~/components/CodeSnippets.js';

export default function Range() {
    return (
        <section className="marginBottom-m">
            <div className="marginBottom-m breakPointM-marginBottom-l">
                <SectionTitle sectionTitle={"Range slider"} />

                <SectionDescription>
                    Range sliders come in one size and two styles applied with{' '}
                    <InlineCode>.range--default</InlineCode> and{' '}
                    <InlineCode>.range--light</InlineCode>.
                </SectionDescription>
            </div>

            <SectionExample>
                <div className="grid grid--1 breakPointL-grid--2">
                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointL-borderBottomWidth-0 breakPointL-borderRightWidth-1">
                        <input type="range" className="range range--default" />
                    </div>

                    <div className="padding-m textAlign-center">
                        <input type="range" className="range range--light" />
                    </div>
                </div>
            </SectionExample>

            <SectionCode codeType="language-html" code={rangeCode} />
        </section>
    );
}



/** WEBPACK FOOTER **
 ** ./src/site/js/pages/components/forms/Range.react.js
 **/